import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { S2S_LINK_FAILURE_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { S2S_LINK_FAILURE_REPORT } from "../interfaces/dashboard";

export default function S2sLinkFailure() {
    const s2sLinkFailureReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.S2S_LINK_FAILURE_REPORT;

    const [s2sLinkFailureReportTableData, setS2sLinkFailureReportTableData] = useState<S2S_LINK_FAILURE_REPORT[]>([]);

    useEffect(() => {
        setS2sLinkFailureReportTableData(S2S_LINK_FAILURE_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="S2S_LINK_FAILURE"
        tableColumns={s2sLinkFailureReportTableColumns}
        tableData={s2sLinkFailureReportTableData} />
    );
}